var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useModalContext } from '../context';
var Inset = function (props) {
    var children = useModalContext(props).children;
    return <Wrapper>{children}</Wrapper>;
};
var Wrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0 -1.5rem;\n  ", "\n"], ["\n  margin: 0 -1.5rem;\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-top: 1px solid ", ";\n    border-bottom: 1px solid ", ";\n    background: 1px solid ", ";\n    padding: 1.5rem;\n  "], ["\n    border-top: 1px solid ", ";\n    border-bottom: 1px solid ", ";\n    background: 1px solid ", ";\n    padding: 1.5rem;\n  "])), theme.colors.PRIMARY.ACCENT_2, theme.colors.PRIMARY.ACCENT_2, theme.colors.PRIMARY.ACCENT_1);
});
export { Inset };
var templateObject_1, templateObject_2;
//# sourceMappingURL=Inset.jsx.map